import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { geteceactivityskillThunk } from "../../ece_activity/EceActivity.Thunk";

// Components
import MuiHeader from "../../../components/MuiHeader";
import MuiLoader from "../../../components/MuiLoader";

// mui
import { Avatar, Button, InputLabel, FormControl, Select, Box, Grid, Card, CardHeader, IconButton, Menu, MenuItem, useMediaQuery, useTheme } from "@mui/material";

// toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// swal
import Swal from "sweetalert2";

function Ece() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // -------------- Loader -----------------------
  const loading = useSelector((state) => state.EceActivitySlice.loading);
  // ---------------------------------------------

  // --------- options for dropdowns ---------
  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];
  const usertype_select_option_list = [
    { value: "fellow", text: "Fellow" },
    { value: "anganwadi", text: "Anganwadi" },
    { value: "school", text: "School" },
  ];
  const class_select_option_list = [
    { value: "1", text: "1" },
    { value: "2", text: "2" },
    { value: "3", text: "3" },
    { value: "4", text: "4" },
    { value: "5", text: "5" },
  ];
  const template_select_option_list = [
    { value: "template1", text: "Template 1" },
    { value: "template2", text: "Template 2" },
    { value: "template3", text: "Template 3" },
    { value: "template4", text: "Template 4" },
    { value: "template5", text: "Template 5" },
  ];
  // ------------------------------------------

  // ------------ dropdowns on change ----------------
  const [preferedlanguage, setPreferedlanguage] = useState("");
  const preflanguage_select_onchange = (event) => {
    setPreferedlanguage(event.target.value);
  };

  const [usertype, setUsertype] = useState("");
  const usertype_select_onchange = (event) => {
    setUsertype(event.target.value);
  };

  const [clas, setClas] = useState("");
  const class_select_onchange = (event) => {
    setClas(event.target.value);
    dispatch(geteceactivityskillThunk(event.target.value));
  };
  const skill_select_option_list = useSelector((state) => state.EceActivitySlice.skills);

  const [skill, setSkill] = useState("");
  const skill_select_onchange = (event) => {
    setSkill(event.target.value);
  };

  const [template, setTemplate] = useState("");
  const template_select_onchange = (event) => {
    setTemplate(event.target.value);
  };
  // -------------------------------------------------

  // ----------- create, update delete button click ----------
  const create_content_button_click = () => {
    const params = {
      module: "ece_activity",
      parameters: {
        preferedlanguage,
        usertype,
        clas,
        skill,
        template,
      },
    };
    const searchParams = new URLSearchParams();
    searchParams.append("params", JSON.stringify(params));

    // put condition here to change url, according to template selected
    const url = `/demotemplate?${searchParams.toString()}`;
    navigate(url);
  };

  const createNewContent = (data) => {};
  // -------------------------------------------------
  return (
    <>
      <div>
        <MuiHeader header="Contents Template for ECE Activity" />
        <FormControl sx={{ m: 1, minWidth: 120 }} style={{ marginTop: 73 }} size="small">
          <InputLabel id="demo-select-small">Language</InputLabel>
          <Select labelId="demo-select-small" id="demo-select-small" value={preferedlanguage} label="Language" onChange={preflanguage_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {language_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ m: 1, minWidth: 120 }} style={{ marginTop: 73 }} size="small">
          <InputLabel id="demo-select-small">Usertype</InputLabel>
          <Select labelId="demo-select-small" id="demo-select-small" value={usertype} label="Subject" onChange={usertype_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {usertype_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ m: 1, minWidth: 120 }} style={{ marginTop: 73 }} size="small">
          <InputLabel id="demo-select-small">Class</InputLabel>
          <Select labelId="demo-select-small" id="demo-select-small" value={clas} label="Class" onChange={class_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {class_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ m: 1, minWidth: 120 }} style={{ marginTop: 73 }} size="small">
          <InputLabel id="demo-select-small">Skill</InputLabel>
          <Select labelId="demo-select-small" id="demo-select-small" value={skill} label="Skill" onChange={skill_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {skill_select_option_list.map((option) => (
              <MenuItem key={option.skillid} value={option.skillid}>
                {option.skillname}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ m: 1, minWidth: 120 }} style={{ marginTop: 73 }} size="small">
          <InputLabel id="demo-select-small">Template</InputLabel>
          <Select labelId="demo-select-small" id="demo-select-small" value={template} label="Class" onChange={template_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {template_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ m: 1, minWidth: 120 }} style={{ marginTop: 73 }} size="small">
          <Button onClick={create_content_button_click} variant="contained">
            Create New Content
          </Button>
        </FormControl>
      </div>

      {/* Loader */}
      <MuiLoader open={loading} />

      {/* Toaster */}
      <ToastContainer />
    </>
  );
}

export default Ece;
